export const ADD_GUIDE = 'ADD_GUIDE';
export const ADD_ALL_GUIDE = 'ADD_ALL_GUIDE';
export const ADD_SELECTED_GUIDE = 'ADD_SELECTED_GUIDE';
